<script setup lang="ts">
</script>

<template>
    <a class="flex items-center gap-x-2 text-lg text-white bg-green-700
              hover:bg-green-800 focus:ring-4
              focus:ring-green-300 font-medium rounded-lg px-5 py-2.5
              dark:bg-green-600 dark:hover:bg-green-700 focus:outline-none
              dark:focus:ring-green-800"
       :href="$route('main.index')">

        <svg class="w-7 h-7 text-gray-800 dark:text-white"
             aria-hidden="true"
             xmlns="http://www.w3.org/2000/svg"
             width="24"
             height="24"
             fill="none"
             viewBox="0 0 24 24">
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m4 12 8-8 8 8M6 10.5V19a1 1 0 0 0 1 1h3v-3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3h3a1 1 0 0 0 1-1v-8.5"/>
        </svg>
    </a>
</template>

<style scoped>

</style>
